export const isProd = window.location.host === "igrayem.com";
